import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { createBrand } from "../../service/ApiServices";
import PropTypes from "prop-types";

const AddBrand = ({onBrandAdded}) => {
  const route = all_routes;
  const navigate = useNavigate();

  const [brandName, setBrandName] = useState('');
  const logo = '';
  const status = true;

  const handleBrandCreate = async (e) => {
      e.preventDefault();
  
  try {
     
      const brandData = {
          name: brandName,
          logo: logo.name,
          status: status
      };
      const createdBrand = await createBrand(brandData);
      console.log('Brand created:', createdBrand);
      navigate(route.addproduct);
      onBrandAdded();
      

  } catch (error) {
      console.error('Error creating brand:', error.message);
  }
  };
  return (
    <>
      {/* Add Brand */}
      <div className="modal fade" id="add-units-brand">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add New Brand</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <div className="mb-3">
                    <label className="form-label">Brand</label>
                    <input
                      type="text"
                      className="form-control"
                      value={brandName}
                      onChange={(e) => setBrandName(e.target.value)}
                    />
                  </div>
                  <div className="modal-footer-btn">
                    <Link
                      to="#"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      className="btn btn-submit"
                      data-bs-dismiss="modal"
                      onClick={handleBrandCreate}
                    >
                      Submit
                    </button>
                    {/* <Link to={route.addproduct} className="btn btn-submit">
                      Submit
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Brand */}
    </>
  );
};

AddBrand.propTypes = {
  onBrandAdded: PropTypes.func.isRequired,
};

export default AddBrand;
